module.exports = __webpack_public_path__ + "img/direction.5d65e3bf.svg";